import {Colors, fullBlack} from '../utils/color.utils' 
const {blue, orange, black, silver, pearl_white, sand} = Colors

class CardMaterial{
    name;
    colors;
    metalness;
    roughness;
    type;
    
    constructor(data){
        this.colors = data.colors ?? []
        this.name = data.name
        this.metalness = data.metalness ?? 1
        this.roughness = data.roughness ?? 0
        this.type = data.type
    }
    
    

    
    
}


export const METAL_CARD = new CardMaterial({
    name: "metal",
    colors: [silver, black],
    type: "m",
    metalness: 1,
    roughness: 0.5,
})


export const PVC_CARD = new CardMaterial({
    name: "pvc",
    colors: [blue, black, sand, pearl_white ] ,
    metalness: 0,
    roughness: 1,
    type: "ps"
    
})

export const ONE_EDITION_CARD = new CardMaterial({
    name: "one_edition_metal",
    colors: [black],
    type: "m",
    metalness: 1,
    roughness: 0.5
})
